export const REDEMPTIONS = {
    CONFIGURATION: '/dashboard/redemptions/configuration',
};

export const redemptionSubHeading =
    'Allow active users to redeem their balance received via Recognitions, Awards & Bonus, Celebrations.';

export const pointsConversionSubHeading = `Set up a conversion rate for each Points which can be redeemed by your teammates for recognitions received.\n E.g., If John sends a Kudos (10 points) to Carol, as per the conversion rate of 1 Point= $2, Carol gets a total of\n $20 that can be redeemed.`;
